const cardItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20scene%20with%20epic%20space%20battle%2C%20dramatic%20lighting%2C%20golden%20explosions%20against%20dark%20space%2C%20cinematic%20color%20grading%2C%20warm%20highlights%2C%20movie%20poster%20aesthetic%2C%20no%20text%2C%20rich%20atmosphere&width=800&height=500&seq=card-recommend-01&orientation=landscape',
    title: '2024年度科幻电影TOP10盘点',
    desc: '从硬核太空史诗到赛博朋克寓言，精选十部必看科幻佳作，每一部都值得反复品味。',
    tag: '科幻',
    tagColor: 'bg-primary-500/15 text-primary-500',
    meta: '12月28日 · 8,520次观看',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20warm%20candlelight%2C%20ornate%20architecture%2C%20historical%20drama%20aesthetic%2C%20rich%20golden%20and%20amber%20tones%2C%20cinematic%20composition%2C%20luxurious%20atmosphere%2C%20no%20people%2C%20film%20poster%20style&width=800&height=500&seq=card-recommend-02&orientation=landscape',
    title: '古装权谋剧推荐：智商在线的十部佳作',
    desc: '从庙堂之高到江湖之远，盘点近年最值得一看的古装权谋精品，剧情环环相扣。',
    tag: '古装',
    tagColor: 'bg-accent-500/15 text-accent-400',
    meta: '12月26日 · 6,340次观看',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20samurai%20battle%2C%20Japanese%20animation%20aesthetic%2C%20warm%20golden%20sunset%20lighting%2C%20epic%20composition%2C%20cinematic%20atmosphere%2C%20vibrant%20colors%20against%20dark%20background%2C%20no%20text&width=800&height=500&seq=card-recommend-03&orientation=landscape',
    title: '日漫入坑指南：8090后最爱的经典番剧',
    desc: '从热血少年到治愈日常，为你整理陪伴8090成长的动漫记忆，青春不老我们不散。',
    tag: '动漫',
    tagColor: 'bg-secondary-500/15 text-secondary-400',
    meta: '12月24日 · 12,800次观看',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Modern%20city%20night%20view%20with%20warm%20neon%20lights%2C%20film%20noir%20aesthetic%2C%20rainy%20streets%20reflecting%20golden%20and%20amber%20glow%2C%20cinematic%20mood%2C%20suspense%20atmosphere%2C%20no%20people%2C%20rich%20dark%20tones&width=800&height=500&seq=card-recommend-04&orientation=landscape',
    title: '悬疑烧脑片单：每一部都让你猜不到结局',
    desc: '反转再反转，结局出人意料。精选高口碑悬疑电影，考验你的推理能力。',
    tag: '悬疑',
    tagColor: 'bg-primary-500/15 text-primary-500',
    meta: '12月22日 · 9,150次观看',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20with%20soft%20golden%20lighting%2C%20comfortable%20atmosphere%2C%20movie%20watching%20setup%20with%20large%20screen%2C%20cinematic%20color%20grading%2C%20relaxed%20evening%20vibe%2C%20rich%20textures%2C%20no%20text&width=800&height=500&seq=card-recommend-05&orientation=landscape',
    title: '周末宅家必看：轻松治愈的高分喜剧片',
    desc: '工作一周辛苦了，打开90影院，让这些欢乐又温暖的影片陪你度过悠闲周末。',
    tag: '喜剧',
    tagColor: 'bg-accent-500/15 text-accent-400',
    meta: '12月20日 · 7,620次观看',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精心甄选优质内容，每一部都值得你的时间
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {cardItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-background-300/60 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-full h-[200px] md:h-[220px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className={`inline-block text-xs px-2.5 py-1 rounded-full font-medium mb-2.5 whitespace-nowrap ${item.tagColor}`}>
                  {item.tag}
                </span>
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {item.desc}
                </p>
                <span className="text-xs text-foreground-400">{item.meta}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}